import { render, staticRenderFns } from "./BaseServerError.vue?vue&type=template&id=0e958cfe&scoped=true&"
import script from "./BaseServerError.vue?vue&type=script&lang=js&"
export * from "./BaseServerError.vue?vue&type=script&lang=js&"
import style0 from "./BaseServerError.vue?vue&type=style&index=0&id=0e958cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e958cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e958cfe')) {
      api.createRecord('0e958cfe', component.options)
    } else {
      api.reload('0e958cfe', component.options)
    }
    module.hot.accept("./BaseServerError.vue?vue&type=template&id=0e958cfe&scoped=true&", function () {
      api.rerender('0e958cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseServerError.vue"
export default component.exports